import { defineStore } from "pinia"
import { ref, watch } from "vue"
import { useRouter, useRoute } from "vue-router"

export const useLangStore = defineStore("lang", () => {
  const router = useRouter()
  const route = useRoute()

  const languages = ref([
    { code: "en", label: "English", flag: "🇺🇸" },
    { code: "fr", label: "Français", flag: "🇫🇷" }
  ])

  const currentLanguage = ref(route.params.lang || "en")

  function setLanguage(code) {
  if (code === currentLanguage.value) return

  const currentRouteLang = route.params.lang

  // Update store
  currentLanguage.value = code

  // Only navigate if route supports :lang AND needs updating
  const routeHasLang = route.matched.some(r => r.path.includes(":lang"))

  if (routeHasLang && currentRouteLang !== code) {
    router.push({
      name: route.name,
      params: { ...route.params, lang: code },
      query: route.query
    })
  }
}

  // Keep store in sync if user manually changes URL
  watch(
    () => route.params.lang,
    (newLang) => {
      if (newLang && newLang !== currentLanguage.value) {
        currentLanguage.value = newLang
      }
    }
  )

  return {
    languages,
    currentLanguage,
    setLanguage
  }
})